/**
 * For usage, see ../TabbedContent.jsx
 *
 * This class is used to filter which 'subcomponents' of the Tabbed content to render within the TabbedContent component
 * There's no logic in here, but the class itself is matched so the correct class must be used
 */

function TabContent(props) {
  return props.children;
}

export default TabContent;
